//import liraries
import React, { Component } from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";
import { COLORS } from "../constant";

const isSmallDevice = Dimensions.get('window').width < 767
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024

// create a component
const applicationStyles = StyleSheet.create({
  loginTextStyle: {
    fontSize: 18.4,
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: 22.1,
    letterSpacing: 0,
    textAlign: "center",
    color: "#ffffff",
    justifyContent: "center",
    paddingLeft: 10,
  },
  buttonTextStyle: {
    fontFamily: "Inter",
    fontSize: 15,
    fontWeight: 600,
    fontStyle: "normal",
    lineHeight: 14,
    letterSpacing: -0.24,
    textAlign: "left",
    color: "#ffffff",
  },
  buttonContainerStyle: {
    alignItems: "center",
    justifyContent: "center",
    //marginTop: 20,
    alignSelf: "center",
    width: "100%",
    height: "100%",
    borderRadius: 20,
    backgroundColor: "#9c1d25",
    shadowColor: "rgba(0, 0, 0, 0.08)",
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowRadius: 5,
    shadowOpacity: 1,
  },
  buttonContainerStyleDisable: {
    alignItems: "center",
    justifyContent: "center",
    //marginTop: 20,
    alignSelf: "center",
    width: "100%",
    height: "100%",
    borderRadius: 18,
    backgroundColor: "#808080",
    shadowColor: "rgba(0, 0, 0, 0.08)",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowRadius: 3,
    shadowOpacity: 1,
  },
  enterOtpDescStyle: {
    textAlign: "center",
    paddingTop: 20,
    opacity: 0.5,
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "500",
    fontStyle: "normal",
    lineHeight: 12,
    letterSpacing: 0,
     color: "#02122c",
    marginHorizontal: "5%",
  },

  enterOtpTxtStyle: {
    marginHorizontal: "10%",
    fontSize: 18,
    marginTop: 30,
    marginBottom: 5,
    fontWeight: "600",
    alignSelf: "center",
    paddingBottom: 5,
    color: "#66625f",
    fontFamily: "Inter",
  },
  textStyle: {
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: 12,
    letterSpacing: 0,
    textAlign: "left",
    color: "#02122c",
  },
  maroonCardStyle: {
    width: isTabView ? 268 : isSmallDevice ? Dimensions.get("window").width/1.2 : 316.5,
    height:isTabView ? 114 : isSmallDevice ? 76 : 122.9,
    backgroundColor: "#c32b2c",
    borderRadius: 15,
    marginLeft: isTabView ? 0 : 20,
    marginRight:20,
    flexDirection: "row",
    alignItems:"center",
    alignSelf:"flex-start",
    justifyContent:'center',
    paddingLeft:38,
    paddingRight:31,
    marginTop: isSmallDevice ? 10 : 20,
    minWidth:isSmallDevice ? 218 : null,
  },
  dropDownWidget: {
    flexDirection:'row',
    zIndex:9999,
    position:'relative',
    zIndex:9999
  },
  dropDownText: {
    fontFamily: "Inter",
    fontSize: 14,
    color: "#fff",
    width:180,
    marginRight:15
  },
  dropDownHeader:{
    backgroundColor:'#fff',
    width:300,
    height:40,
    borderTopLeftRadius:10,
    borderTopRightRadius:10,
    paddingHorizontal:15,
    borderBottomWidth:1,
    borderColor:'rgba(37, 36, 59, 0.4)',
},
dropDownHeaderHide:{
    backgroundColor:'#fff',
    width:300,
    height:40,
    borderRadius:10,
    paddingHorizontal:15,
    borderBottomWidth:1,
    borderColor:'rgba(37, 36, 59, 0.4)'
},
showDropdown:{
    display:'flex',
    backgroundColor:'#fff',
    borderColor:'#dfdfdf',
    borderBottomLeftRadius:10,
    borderBottomRightRadius:10,
    height:200,
    overflow:'scroll',
    width:300,
    position:"absolute",
    top:40,
    zIndex:10
},
hideDropdown:{
    display:'none'
},
listItems:{
    paddingHorizontal:15,
    paddingVertical:8,
    borderBottomWidth:1,
    borderColor:'rgba(37, 36, 59, 0.4)',
    width:'100%'
},
listItem:{
    fontFamily: "Inter",
    fontSize: 16,
    color:'rgba(37, 36, 59, 0.6)'
},
dropDownHeaderText:{
  fontFamily: "Inter",
  fontSize: 16,
  color:'rgba(37, 36, 59, 0.6)'
},

overlayIinlineModal: {
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
  },
  loaderBgIinlineModal: {
          backgroundColor: "white",
          width: 323,
          height: 200,
          borderRadius: 20,
          justifyContent: "flex-start",
          alignItems: "center",
          shadowColor: "rgba(0,0,0,0.05)",
          shadowOpacity: 1.5,
          elevation: 12,
          shadowRadius: 20,
          shadowOffset: { width: 1, height: 13 },
  },
  iconSuccesIinlineModal: {
          marginTop: 25,
          width: 27,
          height: 26,   
         },
  iconErrorIinlineModal: {
          marginVertical: 15,
          width: 45,
          height: 42,
  },
  titleIinlineModal: {
          color: "#5a5755",
          fontFamily: "Inter",
          fontSize: 15,
          alignSelf: "center",
          marginTop: 25,
  },
  footerIinlineModal: {
          width: "100%",
          bottom: 0,
          paddingVertical: 10,
          alignItems: "center",
        },
    footerBtnIinlineModal: {
      width: 63.3,
      height: 30.5,
      borderRadius: 16,
      borderColor: "#d6d6d6",
      borderWidth: 1,
      paddingVertical: 5,
      paddingHorizontal: 10,
      marginTop:10,
      alignItems: "center",
    },
    footerLinkIinlineModal: {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: -0.22,
      textAlign: "left",
      color: "#9d1d27",
      alignSelf:"center",
      paddingTop:2
    },
    mt10:{
      marginTop:10
    },
    mt20:{
      marginTop:20
    },
    mt30:{
      marginTop:30
    },
    mt40:{
      marginTop:40
    },
    mt50:{
      marginTop:50
    },
    mb10:{
      marginBottom:10
    },
    mb20:{
      marginBottom:20
    },
    mb30:{
      marginBottom:30
    },
    mb40:{
      marginBottom:40
    },
    mb50:{
      marginBottom:50
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 40,
      borderRadius: 15,
  },
  overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
      alignItems: "center",
      justifyContent: "center",
  },
  overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
  },
  overlayContentViewStyle:{
    width: '50%',
    minHeight: 310,
    marginTop:'-30%',
    borderRadius: 13,
    backgroundColor: "#ffffff",
    shadowColor: "rgba(0, 0, 0, 0.05)",
    shadowOffset: {
        width: 0,
        height: 27,
    },
    shadowRadius: 34,
    shadowOpacity: 1,
  },
  cir5:{
    width:6,
    height:6,
    borderRadius:3,
    backgroundColor:COLORS.black,
    marginRight:15,
    marginTop:4
  },
  imageUploader: {
    borderWidth:1,
    borderStyle:"dashed",
    borderColor:"#ccd0d5",
    borderRadius: 10,
    height: 120,
    width: 120,
    marginRight: 15,
    backgroundColor: COLORS.white,
    alignItems:'center',
    textAlign:'center',
    justifyContent:'center'
  },
});

//make this component available to the app
export default applicationStyles;
